module.exports = __webpack_public_path__ + "assets/clown.1b3cc1ef4273be1efaa59e89bec2543a6d91d9e238c621f941cbc410090b2d6c.png";